module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/066-chad-5394a00c33fe5557e297d6e6f970f8c9.svg";